<template>
  <card-prime id="card-prime">
    <template #content>
      <div id="responsavel">
        <TituloComponent
          classTitulo="text-blue-800 text-2xl font-bold mb-6"
          titulo="Responsável"
          :exiberLinha="false"
        />
        <div class="formgrid grid">
          <InputTextLabel
            id="responsavel-nome"
            label="Nome completo *"
            classDiv="col-12 md:col-6"
            v-model="v$.Interesse.Responsavel.Nome.$model"
            :temErro="
              (v$.Interesse.Responsavel.Nome.$invalid && submitted) ||
              v$.Interesse.Responsavel.Nome.$pending.$response
            "
            :tamanhoMaximo="82"
          />
          <InputMaskLabel
            id="responsavel-cpf"
            label="CPF *"
            classDiv="col-12 md:col-3"
            v-model="v$.Interesse.Responsavel.Cpf.$model"
            mask="999.999.999-99"
            :temErro="
              (v$.Interesse.Responsavel.Cpf.$invalid && submitted) ||
              v$.Interesse.Responsavel.Cpf.$pending.$response
            "
          />
          <DropDownLabel
            id="responsavel-sexo"
            label="Sexo *"
            classDiv="col-12 md:col-3"
            v-model="v$.Interesse.Responsavel.Sexo.$model"
            :temErro="
              (v$.Interesse.Responsavel.Sexo.$invalid && submitted) ||
              v$.Interesse.Responsavel.Sexo.$pending.$response
            "
            :options="listaSexo"
          />
          <DropDownLabel
            id="responsavel-parentesco"
            label="Parentesco *"
            classDiv="col-12 md:col-3"
            v-model="v$.Interesse.Responsavel.Parentesco.$model"
            :temErro="
              (v$.Interesse.Responsavel.Parentesco.$invalid && submitted) ||
              v$.Interesse.Responsavel.Parentesco.$pending.$response
            "
            :options="listaParentesco"
          />
          <InputTextLabel
            id="responsavel-email"
            label="E-mail *"
            classDiv="col-12 md:col-6"
            v-model="v$.Interesse.Responsavel.Email.$model"
            :temErro="
              (v$.Interesse.Responsavel.Email.$invalid && submitted) ||
              v$.Interesse.Responsavel.Email.$pending.$response
            "
            :tamanhoMaximo="180"
          />
          <InputMaskLabel
            id="responsavel-telefone"
            label="Telefone *"
            classDiv="col-12 md:col-3"
            v-model="v$.Interesse.Responsavel.Telefone.$model"
            :temErro="
              (v$.Interesse.Responsavel.Telefone.$invalid && submitted) ||
              v$.Interesse.Responsavel.Telefone.$pending.$response
            "
            :mask="formatarTelefone()"
          />
        </div>
        <br />
        <div class="card mb-4">
          <div class="flex">
            <div class="flex flex-row flex-wrap">
              <InputSwitch
                id="responsavel-tipo-endereco"
                v-model="enderecoResponsavelIgualAluno"
              />
            </div>
            <div class="flex flex-wrap align-items-center card-container pl-3">
              <span class="text-left vertical-align-text-bottom font-bold"
                >Endereço do responsável é o mesmo do aluno</span
              >
            </div>
          </div>
        </div>
        <EnderecoComponent
          v-if="!enderecoResponsavelIgualAluno"
          :submitted="submitted"
          v-model="Interesse.Responsavel.Endereco"
          :camposObrigatorios="!enderecoResponsavelIgualAluno"
        ></EnderecoComponent>
      </div>
    </template>
  </card-prime>
</template>

<script>
import { required, email } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { useInteresseStore } from "@/store/interesse";
import { useOpcoesStore } from "@/store/opcoes";
import { storeToRefs } from "pinia";
import InputTextLabel from "@/components/comuns/InputTextLabel.vue";
import InputMaskLabel from "@/components/comuns/InputMaskLabel.vue";
import EnderecoComponent from "@/components/detalhesInteresse/EnderecoComponent.vue";
import DropDownLabel from "@/components/comuns/DropDownLabel.vue";
import TituloComponent from "@/components/comuns/TituloComponent.vue";
import CardPrime from "primevue/card";
import ValidacaoMixin from "@/mixins/validacao";

const cpfDeveSerValido = (value) => {
  return ValidacaoMixin.methods.validarCPF(value);
};

export default {
  props: {
    submitted: Boolean,
  },

  components: {
    InputTextLabel,
    DropDownLabel,
    InputMaskLabel,
    EnderecoComponent,
    TituloComponent,
    CardPrime,
  },

  data: () => ({
    listaSexo: [
      { descricao: "Masculino", codigo: "M" },
      { descricao: "Feminino", codigo: "F" },
    ],
  }),

  setup() {
    const storeOpcoes = useOpcoesStore();
    const storeInteresse = useInteresseStore();
    const { Interesse, enderecoResponsavelIgualAluno } = storeToRefs(storeInteresse);
    const { listaParentesco } = storeToRefs(storeOpcoes);

    return { v$: useVuelidate(), Interesse, enderecoResponsavelIgualAluno, listaParentesco };
  },

  name: "ResponsavelComponent",  
  methods:{
    formatarTelefone() {
      if (this.Interesse.Responsavel.Telefone != null) {
        return this.Interesse.Responsavel.Telefone.replace('_','').length <= 14
          ? "(99) 9999-9999?9"
          : "(99) 99999-9999";
      } else {
        return "(99) 9999?9-9999";
      }
    },
  },

  validations() {
    return {
      Interesse: {
        Responsavel: {
          Nome: { required },
          Cpf: {
            required,
            isDate(value) {
              return cpfDeveSerValido(value);
            },
          },
          Sexo: { required },
          Parentesco: { required },
          Email: { required, email },
          Telefone: { required }
        },
      },
    };
  },
};
</script>